import jsonLd from './functions/_jsonLd'
import faq from './functions/faq'

export default function JsonLdFAQ ({ qa }) {
    const faqAvailable = Array.isArray(qa) && qa.length > 0
    return faqAvailable
        ? jsonLd(faq(qa))
        : null
}